module.exports = __webpack_public_path__ + "static/fonts/icomoon.2584c804.ttf";